import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import {
  AssignInfraestructureService,
  Infraestructure,
  InfraestructureDTO,
} from '../../models/infraestructure.interface';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RequestService } from '../request/request';
import { QueryGet } from '../../types/query-types';
import { Pagination } from '../../models/pagination.interface';

@Injectable({
  providedIn: 'root',
})
export class InfraestructureService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'infraestructures/';
  url = environment.service_1 + 'all-infraestructures/';

  urlAdd = environment.service_1 + 'assign-infraestructure-service/';
  urlUpdateAdd = environment.service_1 + 'update-assign-infraestructure-service/';
  urlDelete = environment.service_1 + 'delete-assign-infraestructure-service/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedInfraestructure = new BehaviorSubject<Infraestructure | null>(null);
  selectedInfraestructure$ = this.selectedInfraestructure.asObservable();

  private Infraestructures = new BehaviorSubject<Infraestructure[]>([]);
  Infraestructures$ = this.Infraestructures.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setInfraestructure(infraestructure: Infraestructure) {
    this.selectedInfraestructure.next(infraestructure);
  }

  setInfraestructures(infraestructures: Infraestructure[]) {
    this.Infraestructures.next(infraestructures);
  }

  removeInfraestructureSelected() {
    this.selectedInfraestructure.next(null);
  }

  createInfraestructure(infraestructure: InfraestructureDTO) {
    return this.http.post<Infraestructure>(this.urlPath, infraestructure).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  updateInfraestructure(id: number, infraestructure: InfraestructureDTO & { id: number }) {
    return this.http.put<Infraestructure>(this.urlPath + id + '/', infraestructure).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  addInfraestructure(infraestructure: AssignInfraestructureService) {
    return this.http.post(this.urlAdd, infraestructure).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  updateAddInfraestructure(
    id: number,
    infraestructure: AssignInfraestructureService & { id: number },
  ) {
    return this.http.put(this.urlUpdateAdd + id + '/', infraestructure).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  deleteAssignInfraestructure(id: number): Observable<void> {
    return this.http.delete<void>(this.urlDelete + id + '/');
  }

  getInfraestructure(query: QueryGet): Observable<Pagination<Infraestructure[]>> {
    return this.requestService.get<Infraestructure[]>(this.urlPath, query);
  }

  getInfraestructures(): Observable<Infraestructure[]> {
    return this.http.get<Infraestructure[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }
}
